import logger from "@/services/Logger";

export default class Response {
  constructor(data = {}) {
    if (!("payload" in data)) {
      logger.log("RESPONSE", "Response without payload");
    }

    const { code = null, message = "", payload = {} } = data;

    this.code = code;
    this.message = message;
    this.payload = payload;
  }
}
